module.exports = __webpack_public_path__ + "img/home_color.86690ec6.png";